//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WorkEnvironmentsService from '@/services/work_env_service';
import { userMixin } from '@/mixins/user';
export default {
  name: 'FormResourceResponseComponent',
  mixins: [userMixin],
  props: {
    requestObj: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    typeUpdate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      isLoading: false,
      response: '',
      valid: true
    };
  },
  methods: {
    validate: function validate() {
      return this.$refs.form.validate();
    },
    resetValidation: function resetValidation() {
      return this.$refs.form.resetValidation();
    },
    onCancel: function onCancel(event) {
      event.preventDefault();
      this.resetValidation();
      this.$emit('cancel');
    },
    onApprove: function onApprove(event) {
      var _this = this;
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      this.isLoading = true;
      if (!this.typeUpdate) {
        var data = {
          email: this.requestObj.user_email,
          domain: this.requestObj.domain,
          init: this.requestObj.business_case,
          pr_gcp: this.requestObj.pr_gcp,
          mt: this.requestObj.mt,
          gpu: this.requestObj.gpu || false,
          gitlab: this.requestObj.gitlab || false,
          core: this.requestObj.core,
          sg: this.requestObj.company,
          image: this.requestObj.image,
          steward: this.userEmail,
          response: this.response
        };
        WorkEnvironmentsService.approveResource(data).then(function (response) {
          _this.isLoading = false;
        });
      } else {
        var docIdSplitted = this.requestObj.document_id.split('-');
        docIdSplitted.pop();
        var instanceName = docIdSplitted.join('-');
        var _data = {
          pr_name: this.requestObj.pr_gcp,
          doc_id: this.requestObj.document_id,
          user_email: this.requestObj.user_email,
          pr_firebase: this.requestObj.pr_firebase,
          location: this.requestObj.location,
          instance_name: this.requestObj.instance_name,
          mt: this.requestObj.mt,
          steward: this.userEmail,
          response: this.response
        };
        console.log(_data);
        WorkEnvironmentsService.approveUpdateResource(_data).then(function (response) {
          _this.isLoading = false;
        });
      }
      this.isLoading = false;
      this.$emit('submit', this.requestObj.doc_id);
    },
    onReject: function onReject(event) {
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      this.isLoading = true;
      var params = {
        doc_id: this.requestObj.document_id,
        pr_firebase: this.requestObj.pr_firebase,
        pr_gcp: this.requestObj.pr_gcp,
        email: this.requestObj.user_email,
        update: this.typeUpdate,
        steward: this.userEmail,
        response: this.response
      };
      WorkEnvironmentsService.rejectResource(params);
      this.isLoading = false;
      this.$emit('submit', this.requestObj.doc_id);
    }
  }
};